import { useCheckPermissions } from '@/shared';
import { SaveAreaPage } from '../../shared/saveAreas';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CreateAreaPageInterface {}

const CreateAreaPage: React.FC<CreateAreaPageInterface> = () => {

  useCheckPermissions(PermissionsEnum.api_add_area);
  return <SaveAreaPage titlePage="Crear Area" />;
};

export default CreateAreaPage;
